(function() {
'use strict';

    angular
        .module('app')
        .controller('tsunBulletinNoticeDetailController', tsunBulletinNoticeDetailController);

    function tsunBulletinNoticeDetailController(viewModel) {
        var vm = this;
        vm.data=viewModel.data;
    }
})();